import classNames from 'classnames'
import React, { Component } from 'react'

import RadioInputSvg from '~/graphics/radio-input.svg?raw'

import type { ReactNode } from 'react'

import './radio-input.scss'

export type Props = {
  name: string
  value?: string
  className?: string
  checked?: boolean
  disabled?: boolean
  onChange?: (e: React.SyntheticEvent<HTMLInputElement>) => void
  label?: ReactNode
  description?: ReactNode
  hasError?: boolean
  id?: string
  renderIcon?: (checked: boolean, disabled: boolean) => ReactNode
  readOnly?: boolean
}

const defaultRenderIcon = (checked: boolean, disabled: boolean): ReactNode => (
  <svg
    className={classNames('check-state-icon', {
      checked,
      disabled,
    })}
    dangerouslySetInnerHTML={{ __html: RadioInputSvg }}
  />
)

export default class RadioInput extends Component<Props> {
  renderWrapper(key: string) {
    if (this.props[key]) return <span className={key}>{this.props[key]}</span>
  }

  renderIcon() {
    const renderIconFn = this.props.renderIcon || defaultRenderIcon
    const checked = this.props.checked || false
    const disabled = this.props.disabled || false
    return renderIconFn(checked, disabled)
  }

  render() {
    const {
      className,
      checked,
      disabled,
      label,
      description,
      hasError,
      renderIcon,
      ...inputProps
    } = this.props
    return (
      <label
        className={classNames('amp-radio-input', className, {
          'has-error': hasError,
          checked: checked,
        })}
      >
        <input
          className="input"
          type="radio"
          checked={checked}
          disabled={disabled}
          {...inputProps}
        />
        {this.renderIcon()}
        {this.renderWrapper('label')}
        {this.renderWrapper('description')}
      </label>
    )
  }
}
